/* global $ */

class SlideImg {
  constructor() {
    this.$container = $('.TransitionImg--slide');
    this.$imgSet = [];
    this.current = 0;

    this.$container.find('img').each((i, e) => {
      this.$imgSet.push($(e));
    });
    this.$imgSet[0].css('display', 'block');
  }
  change() {
    this.current++;
    if (this.current >= this.$imgSet.length) this.current = 0;
    for (let i = 0; i < this.$imgSet.length; i++) {
      if (i == this.current) {
        this.$imgSet[i].css('display', 'block');
      } else {
        this.$imgSet[i].css('display', 'none');
      }
    }
  }
}

class LoadingImg {
  constructor() {
    this.$container = $('.TransitionImg--loading');
    this.$imgSet = [];
    this.current = 0;

    this.$container.find('img').each((i, e) => {
      this.$imgSet.push($(e));
    });
    this.$imgSet[0].css('display', 'block');
  }

  change() {
    this.current++;
    if (this.current >= this.$imgSet.length) this.current = 0;
    for (let i = 0; i < this.$imgSet.length; i++) {
      if (i == this.current) {
        this.$imgSet[i].css('display', 'block');
      } else {
        this.$imgSet[i].css('display', 'none');
      }
    }
  }

  init() {
    this.$container.stop(false).animate({ opacity: 0 }, 400, 'easeOutExpo');
  }
  fadein() {
    this.change();
    this.$container.stop(false).animate({ opacity: 1 }, 300, 'easeOutSine');
  }
  fadeout() {
    this.$container.stop(false).animate({ opacity: 0 }, 400, 'easeOutExpo');
  }
}

class Transition {
  constructor() {
    this.$container = $('.Transition');
    this.slideImgChanger = new SlideImg();
    this.slideImg = this.$container.find('.TransitionImg--slide');
    this.loadingImg = new LoadingImg();
    this.isFadeinComplete = true;
    this.onSlidein = false;
    this.isActiveSlidein = false;
  }
  init() {
    this.loadingImg.init();
    this.activeSlideinTimeout = setTimeout(() => {
      this.isActiveSlidein = true;
    }, 4000);
  }
  fadein() {
    clearTimeout(this.activeSlideinTimeout);
    clearInterval(this.waitInterval);
    clearInterval(this.fadeinTimeout);
    this.isFadeinComplete = false;
    this.isActiveSlidein = false;
    this.loadingImg.fadein();

    this.fadeinTimeout = setTimeout(() => {
      this.isFadeinComplete = true;
    }, 500);
    this.activeSlideinTimeout = setTimeout(() => {
      this.isActiveSlidein = true;
    }, 2000);
  }
  fadeout() {
    clearInterval(this.waitInterval);
    if (this.isFadeinComplete) {
      this.loadingImg.fadeout();
    } else {
      this.waitInterval = setInterval(() => {
        if (this.isFadeinComplete) {
          clearInterval(this.waitInterval);
          this.loadingImg.fadeout();
        }
      }, 1000 / 30);
    }
  }
  slidein() {
    if (!this.onSlidein && this.isFadeinComplete && this.isActiveSlidein) {
      this.slideImg.css('top', parseInt(Math.random() * 60 + 20) + '%');
      this.slideImgChanger.change();
      setTimeout(() => {
        this.onSlidein = true;
        clearInterval(this.slideinTimer);
        // クリンパのイラストによってアニメーションの種類を変える #40
        if (this.slideImgChanger.current === 0) {
          this.slideImg.addClass('--fadein');
          this.slideImg.removeClass('is-downward');
        } else {
          this.slideImg.addClass(['--fadein', 'is-downward']);
        }

        this.slideinTimer = setTimeout(() => {
          this.slideImg.removeClass(['--fadein', 'is-downward']);
          clearInterval(this.slideinTimer);
          this.onSlidein = false;
          this.isActiveSlidein = true;
        }, 30000);
      }, 30);
    }
  }

  reset() {
    clearInterval(this.waitInterval);
    clearInterval(this.fadeinTimeout);
    this.slideImg.removeClass('--fadeout');
    this.slideImg.removeClass(['--fadein', 'is-downward']);
  }
}

export default Transition;
